import { TFunction } from 'i18next';
import * as yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const validationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object({
    email: yup
      .string()
      .email(t('userAuth.validationErrors.invalidEmail'))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        t('userAuth.validationErrors.invalidEmailWithoutDomain'),
      )
      .test(
        'forbidden-domains',
        t('userAuth.validationErrors.forbiddenEmailDomain'),
        (value) => {
          if (!value) return true;
          const forbiddenDomains = ['ru', 'by'];
          const domain: string = value?.split('.').pop() || '';
          return !forbiddenDomains.includes(domain);
        },
      )
      .optional(),
    password: yup
      .string()
      .min(8, t('userAuth.validationErrors.minLength'))
      .matches(/^[^\s]*$/, t('userAuth.validationErrors.noSpacesAllowed'))
      .required(t('userAuth.validationErrors.required')),
    repeatPassword: yup
      .string()
      .oneOf(
        [yup.ref('password'), undefined],
        t('userAuth.validationErrors.passwordsMustMatch'),
      )
      .required(t('userAuth.validationErrors.required')),
    phone: yup
      .string()
      .test('is-valid-phone', t('userAuth.validationErrors.invalidPhoneNumber'), (value) => {
        const phoneNumber = parsePhoneNumberFromString(value || '', 'UA');
        return phoneNumber?.isValid() || false;
      })
      .required(t('userAuth.validationErrors.required')),
    checked: yup
      .boolean()
      .oneOf([true], t('userAuth.validationErrors.required'))
      .required(t('userAuth.validationErrors.required')),
  });
